export const SIDEBAR_WIDGET_BORDER_COLOR = "#D2D8DE";

export const SIDEBAR_WIDGET_CARD_SX = {
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  fontFamily: '"Be Vietnam Pro", sans-serif',
  color: "#344054",
  fontSize: 14,
  lineHeight: "24px",
  backgroundColor: "#FFFFFF",
  border: `1px solid ${SIDEBAR_WIDGET_BORDER_COLOR}`,
  borderRadius: 2,
  boxShadow: "none",
  overflow: "hidden",
};

export const SIDEBAR_WIDGET_TITLE_SX = {
  fontFamily: "Be Vietnam Pro",
  fontSize: 16,
  fontWeight: 700,
  color: "#3451F4",
  lineHeight: "24px",
};
